// api.js
/**
 * Send a license image to the scanner API
 * @param {File} imageFile - The license image file to scan
 * @returns {Promise} Promise resolving to the scan results
 */
const Scanner = async (imageFile) => {
	if (!imageFile) {
		throw new Error("No image file provided");
	}

	const formData = new FormData();
	formData.append("image", imageFile);

	try {
		const response = await fetch("https://scanner.dealerclick.com/scan", {
			method: "POST",
			headers: {
				"x-api-key": "aardvark5000",
			},
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.error("License scan failed:", error);
		throw error;
	}
};

export default Scanner;
